import { ContentChildren, Directive, ElementRef, forwardRef, OnDestroy, QueryList } from "@angular/core";
import { Logger } from "@timeghost/web-api";
import { Subject } from "rxjs";
import { TgHintDirective } from "./tg-hint.directive";

const log = new Logger("TgFormfieldDirective");
@Directive({
	selector: "[tg-form-field],[tgFormField],[tgformfield]",
	host: {
		class: "tg-form-field",
	},
})
export class TgFormfieldDirective implements OnDestroy {
	readonly onDestroy = new Subject<void>();
	ngOnDestroy() {
		this.onDestroy.next();
		this.onDestroy.complete();
	}
	@ContentChildren(
		forwardRef(() => TgHintDirective),
		{
			descendants: true,
		}
	)
	hintComponents: QueryList<TgHintDirective> = new QueryList<TgHintDirective>();
	constructor(private el: ElementRef<HTMLElement>) {}
}
